<template>
<div>
  <b-card header="Produtos">
    <Grid name="filterGridProducts" ref="filterGridProducts" v-bind:url="url" v-bind:columns="columns" :pageable='true'  :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
export default {
  name: 'Products',
  components: {
    Grid
  },
  data() {
    return {
      preload: [{
        field: 'product_aggregator_id',
        api: 'prodagregs/lst'
      }, {
        field: 'mpg_id',
        api: 'mpgs/lst'
      }, {
        field: 'brand_id',
        api: 'brands/lst'
      }, {
        field: 'core_id',
        api: 'cores/lst'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'product_aggregator_id': {
          type: 'number'
        },
        'mpg_id': {
          type: 'number'
        },
        'brand_id': {
          type: 'number'
        },
        'core_id': {
          type: 'number'
        }
      },
      url: 'tables/products',
      columns: [{
        width: '160px',
        field: 'sku',
        title: 'SKU'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'product_aggregator_id',
        title: 'ProdAgreg',
        width: '200px',
        values: []
      }, {
        field: 'mpg_id',
        title: 'Gama',
        width: '200px',
        values: []
      }, {
        field: 'brand_id',
        title: 'Marca',
        width: '200px',
        values: []
      }, {
        field: 'core_id',
        title: 'Core',
        width: '200px',
        values: []
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// products.vue?61e70888